import { ReturnTypeEnum } from "@redotech/redo-model/return";
import { ClientReturnFolder } from "@redotech/redo-model/views/folders";
import { ClientReturnView } from "@redotech/redo-model/views/views";
import * as z from "zod/v4";

export const getReturnViewsAndFolders = {
  name: "getReturnViewsAndFolders" as const,
  input: z.object({ type: z.enum(ReturnTypeEnum) }),
  output: z.object({
    views: z.array(ClientReturnView),
    folders: z.array(ClientReturnFolder),
  }),
};
